var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29297 8.125H12.793V9.375H5.29297V8.125ZM5.29297 12.5H10.293V11.25H5.29297V12.5ZM5.29297 15.625H8.41797V14.375H5.29297V15.625ZM3.41797 4.375H5.29297V6.25H12.793V4.375H14.668V8.125H15.918V4.375C15.918 3.68469 15.3583 3.125 14.668 3.125H12.793V2.5C12.793 1.80969 12.2333 1.25 11.543 1.25H6.54297C5.85266 1.25 5.29297 1.80969 5.29297 2.5V3.125H3.41797C2.72766 3.125 2.16797 3.68469 2.16797 4.375V17.5C2.16797 18.1903 2.72766 18.75 3.41797 18.75H6.54297V17.5H3.41797V4.375ZM6.54297 2.5H11.543V5H6.54297V2.5ZM17.7372 18.0847L13.8103 10.8566C13.6391 10.5478 13.196 10.5478 13.0248 10.8566L9.09784 18.0847C8.93491 18.3847 9.15172 18.75 9.49259 18.75H17.3425C17.6833 18.75 17.9002 18.3847 17.7372 18.0847ZM12.9488 13.125H13.8863V15.625H12.9488V13.125ZM13.4175 17.5C13.0724 17.5 12.793 17.2201 12.793 16.875C12.793 16.5299 13.0728 16.25 13.418 16.25C13.7631 16.25 14.043 16.5299 14.043 16.875C14.043 17.2201 13.7627 17.5 13.4175 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentWarning);
export default __webpack_public_path__ + "static/media/ic-document-warning.ea6e37184a4819f6397d407a5b9d12f8.svg";
export { ForwardRef as ReactComponent };